import styled from "styled-components";
import { Heading } from "@viagogo/core/ui";
import { Content } from "src/shared/components/content";
import { CarouselWidthController } from "src/website-apps/responsive/stubhub-home/components/CarouselWidthController";
import { CarouselId } from "src/website-apps/shared/components/carousel-module/carousel-analytics-event";
import { FavoriteEventsCarousel } from "src/website-apps/shared/components/FavoriteEventsCarousel";
import {
  carouselHeaderFontStyleFix,
  carouselHeaderGridSpacingFix,
} from "src/website-apps/shared/components/tm-home-fix-header-sizing/util";
import { useContentLayoutContext } from "src/website-apps/shared/context/ContentLayoutContext";

const HEADER_CONTENT_ID = "cid$#3221765#";
const CAROUSEL_NAME = "upcoming-events-from-your-favorites";
const CAROUSEL_METHOD = "RecommendedBasedOnFavoriteEvents";
const PATH = "/favorites";
const PAGE_SIZE = 4;
// Set to a static value to work around bugs in the ImageCarouselManager component
const NUMBER_OF_PAGES = 2;

const Container = styled.div`
  display: grid;
  grid: auto / 1fr;
  gap: ${({ theme }) => theme.spacing(4)};
  margin-top: ${({ theme, $removePaddingUsedAsMargin }) => ($removePaddingUsedAsMargin ? 0 : theme.spacing(8))};
  @media only screen and (min-width: ${({ theme }) => theme.media.breakpoints.md}px) {
    margin-top: ${({ theme, $removePaddingUsedAsMargin }) => ($removePaddingUsedAsMargin ? 0 : theme.spacing(3))};
  }
  ${carouselHeaderGridSpacingFix};
`;

const Title = styled(Heading)`
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2em;
  color: ${({ theme }) => theme.colors.textDarker};
  margin: 0;
  @media only screen and (min-width: ${({ theme }) => theme.media.breakpoints.md}px) {
    font-size: 20px;
  }
  ${carouselHeaderFontStyleFix};
`;

export const UpcomingEventsBasedOnYourFavoritesHomeSection = ({
  recommendedBasedOnFavoriteEvents,
  renderView,
  size,
}) => {
  const { pageLayoutEnabled } = useContentLayoutContext();
  return (
    <Container $removePaddingUsedAsMargin={pageLayoutEnabled}>
      <Title>
        <Content id={HEADER_CONTENT_ID} />
      </Title>
      <CarouselWidthController>
        <FavoriteEventsCarousel
          id={CAROUSEL_NAME}
          method={CAROUSEL_METHOD}
          numOfPages={NUMBER_OF_PAGES}
          pageSize={PAGE_SIZE}
          carouselName={CAROUSEL_NAME}
          initialEvents={recommendedBasedOnFavoriteEvents}
          headerName={CAROUSEL_NAME}
          renderView={renderView}
          path={PATH}
          size={size}
          analyticsCarouselId={CarouselId.UpcomingEvents}
        />
      </CarouselWidthController>
    </Container>
  );
};
